(function () {

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire7bbe"];
var parcelRegister = parcelRequire.register;
parcelRegister("fPMhU", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $9e574ea5aa0eb496$export$2e2bcd8739ae039; });

var $dTCkE = parcelRequire("dTCkE");

var $cUbQm = parcelRequire("cUbQm");

var $22cn8 = parcelRequire("22cn8");

var $l8eky = parcelRequire("l8eky");

var $515ZP = parcelRequire("515ZP");
const $9e574ea5aa0eb496$var$SEOHeadingComponent = ({ path: path })=>{
    const filterContext = (0, $dTCkE.useContext)((0, $22cn8.FilterContext));
    const [currentPathEstateType, setCurrentPathEstateType] = (0, $dTCkE.useState)(path.estateType !== "bostad" && path.estateType);
    const [currentPathCounty, setCurrentPathCounty] = (0, $dTCkE.useState)();
    const initUrl = window.location.href;
    const [onHold, setOnHold] = (0, $dTCkE.useState)(false);
    const [currentPathMuni, setCurrentPathMuni] = (0, $dTCkE.useState)();
    const [headingToSend, setHeadingToSend] = (0, $dTCkE.useState)("Bost\xe4der till salu");
    const [preambleToSend] = (0, $dTCkE.useState)("Boende med mindre klimatavtryck");
    (0, $dTCkE.useEffect)(()=>{
        if (path.estateType && path.estateType !== "bostad" && path.estateType !== "bra-energiklass") {
            let estateTypeCameled = "";
            estateTypeCameled = (0, $l8eky.makeCamelCase)(path.estateType);
            const inPlural = estateTypeCameled === (0, $cUbQm.EstateType).House ? "Villor" : estateTypeCameled === (0, $cUbQm.EstateType).Cooperative || estateTypeCameled === "Bostadsratt" ? "Bostadsr\xe4tter" : estateTypeCameled === (0, $cUbQm.EstateType).Cottage ? estateTypeCameled : estateTypeCameled === (0, $cUbQm.EstateType).Agriculture || estateTypeCameled === "Gard" ? "G\xe5rdar" : estateTypeCameled === (0, $cUbQm.EstateType).Commercial ? "Kommersiellt" : estateTypeCameled === (0, $cUbQm.EstateType).Plot ? "Tomter" : estateTypeCameled === (0, $cUbQm.EstateType).Project ? "Nyproduktion" : "";
            if (inPlural !== currentPathEstateType) setCurrentPathEstateType(inPlural);
        } else if (path.estateType === "bostad") setCurrentPathEstateType("Bost\xe4der");
        async function createGeoHeading() {
            if (path.muni) {
                const rewrittenMunicip = (0, $l8eky.makeCamelCase)(await (0, $515ZP.getMunicipalityTag)(path.muni));
                setCurrentPathMuni(rewrittenMunicip?.replace("(kommun)", ""));
            } else if (path.county) {
                const rewrittenCounty = (0, $l8eky.makeCamelCase)(await (0, $515ZP.getCountyTag)(path.county));
                setCurrentPathCounty(rewrittenCounty);
            } else setCurrentPathCounty("");
        }
        createGeoHeading();
        setOnHold(true);
    }, [
        filterContext.tags
    ]);
    (0, $dTCkE.useEffect)(()=>{
        let headingToSendOutside = "Bost\xe4der till salu";
        if (initUrl.includes(path.estateType) && !initUrl.includes("bra-energiklass") && onHold) {
            headingToSendOutside = currentPathEstateType + " till salu ";
            if (currentPathMuni) headingToSendOutside = headingToSendOutside + "i " + currentPathMuni;
            else if (currentPathCounty) headingToSendOutside = headingToSendOutside + "i " + currentPathCounty;
        } else if (onHold && initUrl.includes("bra-energiklass")) headingToSendOutside = (0, $cUbQm.ServicesTitles).GreenEstate;
        setHeadingToSend(headingToSendOutside);
    }, [
        currentPathCounty,
        currentPathEstateType,
        currentPathMuni,
        initUrl
    ]);
    (()=>{
        const headingElem = document.getElementById("forSaleHeading");
        headingElem && initUrl.includes(path.estateType) && headingToSend ? headingElem.innerHTML = headingToSend : headingElem && (headingElem.innerHTML = "Bost\xe4der till salu");
    })();
    (()=>{
        const preambleElem = document.getElementById("forSaleSeoPreamble");
        preambleElem && initUrl.includes("bra-energiklass") && preambleToSend ? preambleElem.innerHTML = preambleToSend : preambleElem && (preambleElem.innerHTML = "");
    })();
    return;
};
var $9e574ea5aa0eb496$export$2e2bcd8739ae039 = $9e574ea5aa0eb496$var$SEOHeadingComponent;

});

})();
//# sourceMappingURL=SEOHeadingComponent.15879c69.js.map
